export const ACTIONS = {
  ENABLE: 'rightDrawerTemplates/enable',
  SET_ENFORCE_FOCUS: 'rightDrawerTemplates/set_enforce_focus',
};

export const enableRightDrawerTemplates = value => dispatch => {
  dispatch({ type: ACTIONS.ENABLE, ...value });
  if (window.innerWidth >= 1024) {
    const righrDrawer = document.querySelector('.right-drawer.drawer-templates > .drawer-md-up');

    if (righrDrawer) {
      righrDrawer.style.display = 'block';
    }
  }
};

export const setEnforceFocus = enforceFocus => ({
  type: ACTIONS.SET_ENFORCE_FOCUS,
  payload: { enforceFocus },
});
